// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"PremiumPage_loaderWrapper-Vx7","fixedModal":"PremiumPage_fixedModal-kQJ"};